module.exports = __webpack_public_path__ + "img/tcf_4.427eefa1.png";